import useJoinedTeam from '../../hooks/useJoinedTeam';
import InteractionContainer from '../../components/interactions/InteractionContainer';
import DjHistoryList from '../../components/dj/DjHistoryList';
import { DJ } from '../../constants/Pusher.constants';

const DjHistory = () => {
  const joinedTeam = useJoinedTeam();

  const {color: backgroundColor} = joinedTeam;

  return (
    <InteractionContainer
      backgroundColor={backgroundColor}
      type={DJ}
      isWatchPartyConnected={false}
      content={(
        <DjHistoryList />
      )}
    />
  );
};

export default DjHistory;
